import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="absolute top-0 left-0 right-0 z-50 px-6 py-6" data-id="element-1">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-2">
        {/* Logo - Using CSS filter to make the purple logo white for the dark background */}
        <div className="flex items-center gap-2" data-id="element-3">
          <img src="https://cdn.magicpatterns.com/uploads/pVqK3fgaWQMkP5ESHZaQdg/127905.png" alt="Qlyns Capital" className="h-10 w-auto brightness-0 invert" data-id="element-4" />
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-5">
          <a href="#" className="text-white/90 hover:text-white text-sm font-medium transition-colors" data-id="element-6">
            Startups
          </a>
          <a href="#" className="text-white/90 hover:text-white text-sm font-medium transition-colors" data-id="element-7">
            Investors
          </a>
          <a href="#" className="text-white/90 hover:text-white text-sm font-medium transition-colors" data-id="element-8">
            About
          </a>
          <button className="text-white border border-white/30 px-4 py-2 rounded-md text-sm font-medium hover:bg-white/10 transition-colors" data-id="element-9">
            Login
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-10">
          {isMenuOpen ? <X size={24} data-id="element-11" /> : <Menu size={24} data-id="element-12" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="absolute top-full left-0 right-0 bg-purple-900/95 backdrop-blur-md p-6 md:hidden border-t border-white/10" data-id="element-13">
          <div className="flex flex-col gap-4" data-id="element-14">
            <a href="#" className="text-white font-medium" data-id="element-15">
              Startups
            </a>
            <a href="#" className="text-white font-medium" data-id="element-16">
              Investors
            </a>
            <a href="#" className="text-white font-medium" data-id="element-17">
              About
            </a>
            <button className="text-white border border-white/30 px-4 py-2 rounded-md font-medium text-left" data-id="element-18">
              Login
            </button>
          </div>
        </div>}
    </header>;
}